<template>
  <el-container style="height: 100%;min-width:1135px" class="box">
    <el-aside class="side-menu" :style="{width:menu.sidebar.width+'px'}">
      <side-menu>
        <router-link to="/">
          <!-- <i v-if="menu.collapsed" class="el-icon-s-platform logo" style="width:35px"></i> -->
          <div class="logobox">
            <img :src="logo" alt class="logoimg" />
            <div v-if="!menu.collapsed" class="logo">店长助手商户后台</div>
          </div>
        </router-link>
      </side-menu>
    </el-aside>
    <el-container>
      <el-header>
        <header-bar>
          <div v-if="middle&&!version" class="avator">
            <img class="mr10" :src="avator" />
            <span>{{permission.roleName}}</span>
          </div>
          <el-popover v-else placement="top" width="160" trigger="hover">
            <div slot="reference" class="avator">
              <img class="mr10" :src="avator" />
              <span>{{permission.roleName}}</span>
            </div>
            <div v-if="!middle" class="reset" @click="setPassword">修改密码</div>
            <a v-if="!version" class="logout reset" href="/wsg/logout">退出登录</a>
            <div v-else class="reset" @click="logout">退出登录</div>
          </el-popover>
        </header-bar>
      </el-header>
       <div class="public-tips" v-if="expireCount">您好，您有{{this.expireCount}}家门店授权即将逾期/已经超期，超出授权有效期后无法使用，请及时联系您的商务对接伙伴沟通授权事宜，超出授权有效期的门店将无法使用。<span class="see-details" @click="seeDetails">查看详情<i class="el-icon-circle-close " @click.stop="closeTips"></i></span></div>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
    <el-dialog :visible.sync="visible" width="420px" title="密码修改" @closed="clearPwd">
      <el-form :model="form" ref="form" :rules="rules" label-width="110px">
        <el-form-item label="旧的密码" prop="oldPwd">
          <el-input style="width:220px" v-model="form.oldPwd" placeholder="请输入旧的密码"  show-password></el-input>
        </el-form-item>
        <el-form-item label="新的密码" prop="newPwd">
          <el-input style="width:220px" v-model="form.newPwd" placeholder="请输入新的密码"  show-password></el-input>
        </el-form-item>
        <el-form-item class="red-star" label="确认密码" prop="rePwd">
          <el-input  style="width:220px" v-model="form.rePwd" placeholder="请再次输入修改后的密码"  show-password></el-input>
        </el-form-item>
      </el-form>
      <div class="text_center">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveEdit(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-backtop :visibility-height="600" target=".el-main"></el-backtop>
  </el-container>
</template>

<script>
import SideMenu from './components/side-menu/SideMenu'
import HeaderBar from './components/header-bar'
import avator from '@/assets/image/avator.png'
import logo from '@/assets/image/LOGO.png'
import config from '@/config'
import { mapState } from 'vuex'
import { modifyPwd,expireStoreCount } from '@/api/request'
export default {
  data () {
    return {
      middle: this.$config.middle,
      version: this.$config.version=="h5",
      avator,
      logo,
      visible: false,
      expireCount:0, // 快过期门店数量
      form:{
        oldPwd:'',
        newPwd:'',
        rePwd:'',
      },
      rules: {
        oldPwd: [{ required: true, message: "请输入旧的密码", trigger: "blur" }],
        newPwd: [{ required: true, message: "请输入新的密码", trigger: "blur" }],
        rePwd: [{ validator: this.checkPassword, trigger: 'blur' }],
      }
    }
  },
  components: {
    SideMenu,
    HeaderBar
  },
  computed: {
    ...mapState(['menu','permission']),
  },
  created() {
    // roleType 只有当 roleType 是 0 的时候才去调用expireStoreCount接口，roleType 是 0 表示是系统管理员
    if(JSON.parse(sessionStorage.getItem("userInfo")).roleType === "0") {
          expireStoreCount().then(res=> {
      this.expireCount= parseInt(res.data)
      this.$store.commit('SET_EXPIRE_COUNT',this.expireCount)
    })
    }

  },
  methods: {
    setPassword() {
      this.visible = true
    },
    checkPassword(rule, value, callback) {
      if(!this.form.rePwd){
        return callback(new Error('请再次输入密码'))
      }
      if(this.form.rePwd !== this.form.newPwd){
        return callback(new Error('两次输入的密码不一致'))
      }
      return callback()
    },
    logout() {
      this.$router.push("/login")
    },
    clearPwd() {
      this.form = {}
    },
    saveEdit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          modifyPwd({oldPwd:this.form.oldPwd,newPwd:this.form.newPwd}).then(res=>{
            if(res.success){
              this.$message.success('密码修改成功')
              this.visible = false
            }
          })
        }
      })
    },
    closeTips() {
      this.expireCount = 0
      this.$store.commit('SET_EXPIRE_COUNT',this.expireCount)
    },
    seeDetails() {
      this.$router.push("/storeArchives?isExpire=true")
    }
  },
}
</script>

<style lang='less' scoped>
.el-header {
  color: #333;
  text-align: left;
  line-height: 60px;
  height: 60px;
  padding: 0;
  border-bottom: 1px solid #e9eef3;
}
.reset {
  line-height: 40px;
  text-align: center;
  color: #333;
  cursor: pointer;
  &:hover{
    color: #3897FF;
    background: #e9eef3;
  }
}
.el-main {
  background-color: #e9eef3;
  color: #333;
}
body > .el-container {
  margin-bottom: 40px;
}
.avator {
  // cursor: pointer;
  height: 60px;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
  img {
    width: 50px;
    border-radius: 25px;
    border: 1px solid #ddd;
  }
}
.logout {
  width: 100%;
  display: block;
  text-align: center;
  color: #333;
}
.logoimg {
  width: 40px;
  margin: 0 10px;
  vertical-align: middle;
}
.logobox {
  height: 60px;
  border-bottom: 1px solid #454b61;
  line-height: 60px;
}
.logo {
  display: inline-block;
  color: #fff;
  line-height: 60px;
  text-align: center;
}
.public-tips {
  // position: relative;
  // top: 64px;
  padding: 0 30px;
  height: 30px;
  min-height: 30px;
  white-space:nowrap;
  // z-index: 9999;
  font-size: 14px;
  color: red;
  display: flex;
  align-items: center;
  background-color: #fff;
  .see-details {
    color: blue;
    margin-left: 10px;
    display: flex;
    align-items: center;
    .el-icon-circle-close {
      font-size: 16px;
      margin-left: 10px;
     
    }
  }
}
</style>
